import { Box, Flex, Image, Float } from '@chakra-ui/react';
import type { Msg, User } from '@halo/chat-sdk';
import { DefAvatarIcon, onImageError } from '@halo/ui-chat-react';
import { formatAmount } from '@halo/wallet-app';

export interface MessageTransferProps {
  message: Msg;
  isMy?: boolean;
  isGroup?: boolean;
  toUser?: User;
  onClick?: (message: Msg) => void;
}

export function MessageTransfer({
  message,
  isMy,
  isGroup,
  toUser,
  onClick,
}: MessageTransferProps) {
  const { chainIcon, tokenIcon, amount, symbol, desc } = message?.payload ?? {};

  return (
    <Box
      className="MessageTransfer"
      w="240px"
      m="-2.5"
      mb="0"
      px="3"
      pt="2.5"
      cursor="pointer"
      onClick={() => onClick?.(message)}
    >
      {isGroup && (
        <Box fontWeight="semibold" color="white" fontSize="xs" mb="2" truncate>
          Transfer to {toUser?.name}
        </Box>
      )}
      <Flex className="TransferBody" align="center" gap="2">
        <Box className="TransferIcon" pos="relative" width="9" height="9" flexShrink="0">
          <Image
            src={tokenIcon || (DefAvatarIcon as any)}
            alt="info"
            width="9"
            height="9"
            borderRadius="full"
            onError={onImageError}
          />
          <Float placement="bottom-end" offsetX="1" offsetY="1">
            <Image
              src={chainIcon || (DefAvatarIcon as any)}
              alt="info"
              width="4.5"
              height="4.5"
              borderRadius="full"
            />
          </Float>
        </Box>
        <Box className="TransferContent" flex="1">
          <Box
            className="TransferAmount"
            maxW="115px"
            truncate
            fontSize="lg"
            fontWeight="semibold"
            color="white"
          >
            {formatAmount(amount, { unit: symbol })}
          </Box>
          <Box
            className="TransferDesc"
            fontSize="xs"
            fontWeight="medium"
            color="white"
            maxW="175px"
            truncate
          >
            {desc}
          </Box>
        </Box>
      </Flex>
      <Flex
        className="TransferBorder"
        my="2"
        borderBottom={isMy ? '1px solid' : 'none'}
        borderColor="blackAlpha.10"
      ></Flex>
    </Box>
  );
}
